// van-search 输入框只能输入字母及数字
import Vue from 'vue';

Vue.directive('alphabet', {
  inserted: function(el) {
    const input = el.querySelector('.van-field__control');
    input.onkeyup = function() {
      input.value = input.value.replace(/[^A-Za-z0-9]/g, '');
    };
    input.onblur = function() {
      input.value = input.value.replace(/[^A-Za-z0-9]/g, '');
    };
  }
});
